export const RECEIVED_KNOWLEDGES_INFINITE_LOADING = 'RECEIVED_KNOWLEDGES_INFINITE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/knowledge/mutation-types.js